import * as React from 'react';
import {Breadcrumb, Grid} from 'semantic-ui-react';
import i18n from '../../../../locale/i18n';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {
    ColumnSelectableComponentProps,
    ColumnSortableComponentProps,
    FilterObjectComponentProps,
    InfinityScrollComponentProps,
    ViewSettingsComponentProps,
    withColumnSelection,
    withColumnSort,
    withFilterObject,
    withInfinityScrollHandlers,
    withPrintAndExport,
    withViewSettings
} from '../../components/DataTable/dataService';
import {DataTable} from '../../components/DataTable/DataTable';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../components/DataTable/common';
import ContentContainer from '../../containers/ContentContainer/ContentContainer';
import {ColumnSelectionButton} from '../../components/DataTable/ColumnSelection';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import _get from 'lodash/get';
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";
import LogisticsAvalancheServiceSingleton from "../../services/LogisticAvalancheService";
import Moment from "react-moment";
import moment from "moment";

const t = i18n.t.bind(i18n);


let COLUMNS: ColumnDefinition[] = [
    {labelTranslationKey: 'Inventory.Account', fieldName: 'data.depotNr'}, // by default only for export/print
    {labelTranslationKey: "Inventory.Region", fieldName: "data.region", required: true,
        cellRender: (v,row) =>  <NavLink to={`/logistics/inventory-avalanche-region/${row.data.depotNr}/${row.data.artikelNr}/${row.data.regionGroup}/`}>{v}</NavLink>},
    {labelTranslationKey: "Inventory.LTNumber", fieldName: "data.artikelNr"},
    {labelTranslationKey: "Inventory.ShortText", fieldName: "data.artikelName"}, // by default only for export/print
    {labelTranslationKey: "InventoryAccountType.Count1", fieldName: "data.bestand1", cellAlign: 'right'},
    {labelTranslationKey: "InventoryAccountType.Count2", fieldName: "data.bestand2", cellAlign: 'right'},
    {labelTranslationKey: "InventoryAccountType.Count3", fieldName: "data.bestand3", cellAlign: 'right'},
    {labelTranslationKey: "InventoryAccountType.Count4", fieldName: "data.bestand4", cellAlign: 'right'},
    {labelTranslationKey: "InventoryAccountType.Count5", fieldName: "data.bestand5", cellAlign: 'right'},
    {labelTranslationKey: "InventoryAccountType.Date", fieldName: "data.datum",
        cellRender: (v,r) => (v!== "") && <Moment format={t("Common.DateFormat")}>{v}</Moment>,
        printExportRender: (v,r) => moment(v).format(t("Common.DateFormat"))
    }
];

const getScrollParent = () => ContentContainer.instance.componentRef.current;

// filter out print/export columns in default columns
const DEFAULT_COLUMNS = COLUMNS.map(c => c.fieldName).filter(f => (f !== 'data.depotNr' && f !== 'data.artikelName'));

const PageComponent = (props: RouteComponentProps<{accountNumber: string; ltNumber: string;}> & InfinityScrollComponentProps & ColumnSelectableComponentProps & ColumnSortableComponentProps & FilterObjectComponentProps & ViewSettingsComponentProps) => {
    if(props.loadingInitial) {
        return <LoadingContainer showLogo={false}/>;
    }

    COLUMNS = [
        {labelTranslationKey: 'Inventory.Account', fieldName: 'data.depotNr'}, // by default only for export/print
        {labelTranslationKey: "Inventory.Region", fieldName: "data.region", required: true,
            cellRender: (v,row) =>  <NavLink to={`/logistics/inventory-avalanche-region/${row.data.depotNr}/${row.data.artikelNr}/${row.data.regionGroup}/`}>{v}</NavLink>},
        {labelTranslationKey: "Inventory.LTNumber", fieldName: "data.artikelNr"},
        {labelTranslationKey: "Inventory.ShortText", fieldName: "data.artikelName"}, // by default only for export/print
        {labelTranslationKey: "InventoryAccountType."+ props.match.params.ltNumber +".Count1", fieldName: "data.bestand1", cellAlign: 'right'},
        {labelTranslationKey: "InventoryAccountType."+ props.match.params.ltNumber +".Count2", fieldName: "data.bestand2", cellAlign: 'right'},
        {labelTranslationKey: "InventoryAccountType."+ props.match.params.ltNumber +".Count3", fieldName: "data.bestand3", cellAlign: 'right'},
        {labelTranslationKey: "InventoryAccountType."+ props.match.params.ltNumber +".Count4", fieldName: "data.bestand4", cellAlign: 'right'},
        {labelTranslationKey: "InventoryAccountType."+ props.match.params.ltNumber +".Count5", fieldName: "data.bestand5", cellAlign: 'right'},
        {labelTranslationKey: "InventoryAccountType.Date", fieldName: "data.datum",
            cellRender: (v,r) => (v!== "") && <Moment format={t("Common.DateFormat")}>{v}</Moment>,
            printExportRender: (v,r) => moment(v).format(t("Common.DateFormat"))
        }
    ];

    const getAccountName = () => {
        if(props.data != null) {
            return _get(props.data, '0.data.depotName', '');
        }
        return '';
    };

    const getLtName = () => {
        if(props.data != null) {
            return _get(props.data, '0.data.artikelName', '');
        }
        return '';
    };

    return (
        <>
            <AnalyticsTracking page="logistics-avalanche/account/region" />
            <div className={"sticky-header"}>
                <div className={"ui container"}>
                    <h3><Breadcrumb icon="right angle" sections={[
                        {key: '1',
                            as: NavLink,
                            to: '/logistics/inventory-avalanche',
                            content: `${t("Route.InventoryAvalanche")}`, link: true},
                        {key: '2',
                            content: `${t("Inventory.Account")}: ${props.match.params.accountNumber} ${getAccountName()}`,
                            active: true
                        },{key: '3',
                            content: `${t("Inventory.LTNumber")}: ${props.match.params.ltNumber} ${getLtName()}`,
                            active: true
                        },
                    ]}/></h3>
                    <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>
                    <Grid columns={3} className={"HeadingGrid"} stackable={true}
                          style={{marginBottom: '1em'}}>
                        <Grid.Column width={11}>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <ColumnSelectionButton
                                fluid
                                availableColumns={COLUMNS}
                                selectedColumns={props.selectedColumns}
                                onSave={props.updateSelectedColumns}/>
                        </Grid.Column>
                        <Grid.Column width={1}>
                            <div style={{opacity: (props.loading) ? '1.0' : '0.0', width:"100%"}}>
                                <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                                </div>
                            </div>
                        </Grid.Column>
                    </Grid>
                </div>
            </div>
            <div className={"ui container responsivewrapper"}>
                <DataTable
                    columns={COLUMNS}
                    data={props.data}
                    page={props.page}
                    totalPages={props.totalPages}
                    sortDirection={props.sortDirection}
                    sortColumn={props.sortColumn}
                    selectedColumns={props.selectedColumns}
                    getScrollParent={getScrollParent}
                    loadMore={props.loadMore}
                    handleSortChange={props.handleSortChange}
                    loading={props.loading}
                />
                <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
                    <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                    </div>
                </div>
                <div style={{height: '2em'}}/>
            </div>
        </>
    )
};

const WrappedComponent = withRouter(withViewSettings(withFilterObject(withColumnSort(withColumnSelection(withPrintAndExport(withInfinityScrollHandlers(PageComponent)))))));

export default (props: RouteComponentProps<{accountNumber: string; ltNumber: string;}>) => {
    const dataService = {
        loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }, size?: number): Promise<any> {
            return LogisticsAvalancheServiceSingleton.getInventoryAggregations(props.match.params.accountNumber, props.match.params.ltNumber, sortColumn, sortOrder, page, size);
        }
    };
    return (
        <WrappedComponent
            viewName="inventory-avalanche_byaccountlt_region"
            dataService={dataService}
            defaultSortDirection="ASC"
            defaultSortColumn="region"
            defaultColumns={DEFAULT_COLUMNS}
            defaultFilter={{
            }}
            printColumns={COLUMNS}
            printPath={[
                `${t("Route.InventoryAvalanche")}`,
                `${t("Inventory.Account")}: ${props.match.params.accountNumber}; ${t("Inventory.LTNumber")}: ${props.match.params.ltNumber}` // TODO add account Name and lt Name?!
            ]}
        />
    );

}
